/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type DevelopmentConfirmationStep_form$ref = any;
type DevelopmentFirstBuyerStep_form$ref = any;
type DevelopmentFirstBuyerStep_root$ref = any;
type DevelopmentSecondBuyerStep_form$ref = any;
type DevelopmentSecondBuyerStep_root$ref = any;
type developmentVerificationStep_form$ref = any;
type developmentVerificationStep_root$ref = any;
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
export type DevelopmentRegistrationQueryVariables = {|
  id: string,
  skip: boolean,
|};
export type DevelopmentRegistrationQueryResponse = {|
  +developmentRegistrationForm?: ?{|
    +id?: string,
    +step?: ?DevelopmentRegistrationStep,
    +developmentProduct?: ?{|
      +slug: string
    |},
    +numberOfBuyers?: ?number,
    +$fragmentRefs: DevelopmentFirstBuyerStep_form$ref & DevelopmentSecondBuyerStep_form$ref & developmentVerificationStep_form$ref & DevelopmentConfirmationStep_form$ref,
  |},
  +$fragmentRefs: DevelopmentFirstBuyerStep_root$ref & DevelopmentSecondBuyerStep_root$ref & developmentVerificationStep_root$ref,
|};
export type DevelopmentRegistrationQuery = {|
  variables: DevelopmentRegistrationQueryVariables,
  response: DevelopmentRegistrationQueryResponse,
|};
*/


/*
query DevelopmentRegistrationQuery(
  $id: ID!
  $skip: Boolean!
) {
  ...DevelopmentFirstBuyerStep_root
  ...DevelopmentSecondBuyerStep_root
  ...developmentVerificationStep_root
  developmentRegistrationForm: node(id: $id) @skip(if: $skip) {
    __typename
    ... on DevelopmentRegistrationForm {
      ...DevelopmentFirstBuyerStep_form
      ...DevelopmentSecondBuyerStep_form
      ...developmentVerificationStep_form
      ...DevelopmentConfirmationStep_form
      id
      step
      developmentProduct {
        slug
        id
      }
      numberOfBuyers
    }
    id
  }
}

fragment DevelopmentConfirmationStep_form on DevelopmentRegistrationForm {
  id
  hasLandForSale
  developmentProduct {
    id
    slug
    title
  }
}

fragment DevelopmentFirstBuyerStep_form on DevelopmentRegistrationForm {
  id
  completed
  phoneNumber
  firstBuyerNationality {
    id
    label
    name
  }
  firstBuyerOccupation {
    id
    label
  }
  firstBuyerWorkPermit {
    id
    label
  }
  firstBuyerFirstName
  firstBuyerLastName
  firstBuyerDateOfBirth
  firstBuyerEmailAddress
  firstBuyerPhoneNumber
  firstBuyerAnnualRevenues
  firstBuyerSavings
  numberOfBuyers
  isAlreadyOwner
  secondBuyerFirstName
  secondBuyerLastName
  step
  product {
    id
  }
  developmentProduct {
    id
    products {
      id
      lotReference
      currency
      salePrice
      status
      property {
        id
        numberOfRooms
        floorOfFlat
        numberOfFloors
      }
    }
  }
}

fragment DevelopmentFirstBuyerStep_root on Query {
  me {
    id
    firstName
    dateOfBirth
    nationality {
      id
      label
      name
    }
    occupation {
      id
      label
    }
    workPermit {
      id
    }
  }
  workPermitTypes: dictionaries(type: "work_permit_types") {
    id
    label
    name
  }
  occupationTypes: dictionaries(type: "occupation_types") {
    id
    label
    name
  }
  nationalityTypes: dictionaries(type: "nationality_types") {
    id
    label
    name
  }
}

fragment DevelopmentSecondBuyerStep_form on DevelopmentRegistrationForm {
  id
  step
  secondBuyerFirstName
  secondBuyerLastName
  secondBuyerDateOfBirth
  secondBuyerPhoneNumber
  secondBuyerSavings
  secondBuyerAnnualRevenues
  secondBuyerNationality {
    id
    name
  }
  secondBuyerOccupation {
    id
  }
  secondBuyerWorkPermit {
    id
  }
}

fragment DevelopmentSecondBuyerStep_root on Query {
  workPermitTypes: dictionaries(type: "work_permit_types") {
    id
    name
    label
  }
  occupationTypes: dictionaries(type: "occupation_types") {
    id
    name
    label
  }
  nationalityTypes: dictionaries(type: "nationality_types") {
    id
    name
    label
  }
}

fragment developmentVerificationStep_form on DevelopmentRegistrationForm {
  id
  verified
  completed
}

fragment developmentVerificationStep_root on Query {
  me {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "step",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBuyers",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = [
  (v2/*: any*/),
  (v6/*: any*/)
],
v10 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DevelopmentRegistrationQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DevelopmentFirstBuyerStep_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DevelopmentSecondBuyerStep_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "developmentVerificationStep_root"
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "developmentRegistrationForm",
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DevelopmentProduct",
                    "kind": "LinkedField",
                    "name": "developmentProduct",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DevelopmentFirstBuyerStep_form"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DevelopmentSecondBuyerStep_form"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "developmentVerificationStep_form"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DevelopmentConfirmationStep_form"
                  }
                ],
                "type": "DevelopmentRegistrationForm",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DevelopmentRegistrationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOfBirth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "nationality",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "occupation",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "workPermit",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "workPermitTypes",
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "work_permit_types"
          }
        ],
        "concreteType": "Dictionary",
        "kind": "LinkedField",
        "name": "dictionaries",
        "plural": true,
        "selections": (v8/*: any*/),
        "storageKey": "dictionaries(type:\"work_permit_types\")"
      },
      {
        "alias": "occupationTypes",
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "occupation_types"
          }
        ],
        "concreteType": "Dictionary",
        "kind": "LinkedField",
        "name": "dictionaries",
        "plural": true,
        "selections": (v8/*: any*/),
        "storageKey": "dictionaries(type:\"occupation_types\")"
      },
      {
        "alias": "nationalityTypes",
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "nationality_types"
          }
        ],
        "concreteType": "Dictionary",
        "kind": "LinkedField",
        "name": "dictionaries",
        "plural": true,
        "selections": (v8/*: any*/),
        "storageKey": "dictionaries(type:\"nationality_types\")"
      },
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "developmentRegistrationForm",
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phoneNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "firstBuyerNationality",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "firstBuyerOccupation",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "firstBuyerWorkPermit",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstBuyerFirstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstBuyerLastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstBuyerDateOfBirth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstBuyerEmailAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstBuyerPhoneNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstBuyerAnnualRevenues",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstBuyerSavings",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAlreadyOwner",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondBuyerFirstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondBuyerLastName",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DevelopmentProduct",
                    "kind": "LinkedField",
                    "name": "developmentProduct",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lotReference",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "salePrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Property",
                            "kind": "LinkedField",
                            "name": "property",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfRooms",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "floorOfFlat",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfFloors",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondBuyerDateOfBirth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondBuyerPhoneNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondBuyerSavings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "secondBuyerAnnualRevenues",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "secondBuyerNationality",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "secondBuyerOccupation",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "secondBuyerWorkPermit",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "verified",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasLandForSale",
                    "storageKey": null
                  }
                ],
                "type": "DevelopmentRegistrationForm",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9cff7f64aee8a4b6936c814aa54b788f",
    "id": null,
    "metadata": {},
    "name": "DevelopmentRegistrationQuery",
    "operationKind": "query",
    "text": "query DevelopmentRegistrationQuery(\n  $id: ID!\n  $skip: Boolean!\n) {\n  ...DevelopmentFirstBuyerStep_root\n  ...DevelopmentSecondBuyerStep_root\n  ...developmentVerificationStep_root\n  developmentRegistrationForm: node(id: $id) @skip(if: $skip) {\n    __typename\n    ... on DevelopmentRegistrationForm {\n      ...DevelopmentFirstBuyerStep_form\n      ...DevelopmentSecondBuyerStep_form\n      ...developmentVerificationStep_form\n      ...DevelopmentConfirmationStep_form\n      id\n      step\n      developmentProduct {\n        slug\n        id\n      }\n      numberOfBuyers\n    }\n    id\n  }\n}\n\nfragment DevelopmentConfirmationStep_form on DevelopmentRegistrationForm {\n  id\n  hasLandForSale\n  developmentProduct {\n    id\n    slug\n    title\n  }\n}\n\nfragment DevelopmentFirstBuyerStep_form on DevelopmentRegistrationForm {\n  id\n  completed\n  phoneNumber\n  firstBuyerNationality {\n    id\n    label\n    name\n  }\n  firstBuyerOccupation {\n    id\n    label\n  }\n  firstBuyerWorkPermit {\n    id\n    label\n  }\n  firstBuyerFirstName\n  firstBuyerLastName\n  firstBuyerDateOfBirth\n  firstBuyerEmailAddress\n  firstBuyerPhoneNumber\n  firstBuyerAnnualRevenues\n  firstBuyerSavings\n  numberOfBuyers\n  isAlreadyOwner\n  secondBuyerFirstName\n  secondBuyerLastName\n  step\n  product {\n    id\n  }\n  developmentProduct {\n    id\n    products {\n      id\n      lotReference\n      currency\n      salePrice\n      status\n      property {\n        id\n        numberOfRooms\n        floorOfFlat\n        numberOfFloors\n      }\n    }\n  }\n}\n\nfragment DevelopmentFirstBuyerStep_root on Query {\n  me {\n    id\n    firstName\n    dateOfBirth\n    nationality {\n      id\n      label\n      name\n    }\n    occupation {\n      id\n      label\n    }\n    workPermit {\n      id\n    }\n  }\n  workPermitTypes: dictionaries(type: \"work_permit_types\") {\n    id\n    label\n    name\n  }\n  occupationTypes: dictionaries(type: \"occupation_types\") {\n    id\n    label\n    name\n  }\n  nationalityTypes: dictionaries(type: \"nationality_types\") {\n    id\n    label\n    name\n  }\n}\n\nfragment DevelopmentSecondBuyerStep_form on DevelopmentRegistrationForm {\n  id\n  step\n  secondBuyerFirstName\n  secondBuyerLastName\n  secondBuyerDateOfBirth\n  secondBuyerPhoneNumber\n  secondBuyerSavings\n  secondBuyerAnnualRevenues\n  secondBuyerNationality {\n    id\n    name\n  }\n  secondBuyerOccupation {\n    id\n  }\n  secondBuyerWorkPermit {\n    id\n  }\n}\n\nfragment DevelopmentSecondBuyerStep_root on Query {\n  workPermitTypes: dictionaries(type: \"work_permit_types\") {\n    id\n    name\n    label\n  }\n  occupationTypes: dictionaries(type: \"occupation_types\") {\n    id\n    name\n    label\n  }\n  nationalityTypes: dictionaries(type: \"nationality_types\") {\n    id\n    name\n    label\n  }\n}\n\nfragment developmentVerificationStep_form on DevelopmentRegistrationForm {\n  id\n  verified\n  completed\n}\n\nfragment developmentVerificationStep_root on Query {\n  me {\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b27ff0bb97ed6f836bc83d97b35259e2';

export default node;
